import { Modal } from 'react-bootstrap';
import withTranslations from '../../../utils/HighOrderComponent';
import CustomButton from '../CustomButton';

const ModalFooter = (props) => {
  const {
      gt,
      submitRef,
      hideFooterCancelButton,
      hideSaveButton,
      showCloseButton,
      exportButton,
      footerContent,
      saveButtonClassName,
      customSaveButtonLabel,
      customSaveButtonIcon,
      onCancelActionHandler,
    } = props || {},
    { Tooltips, Button } = gt || {};

  const saveButtonLabel = customSaveButtonLabel || Button.saveData;
  const saveButtonIcon = customSaveButtonIcon || (
    <i className="fa-regular fa-floppy-disk" />
  );

  return (
    <Modal.Footer className="gap-2">
      {footerContent &&
        (typeof footerContent === 'function'
          ? footerContent?.()
          : footerContent)}
      {exportButton && (
        <CustomButton
          className={'default-btn-success'}
          label={Button.export}
          startIcon={<i className="fa-solid fa-file-pen"></i>}
          onClick={() => submitRef?.current?.click()}
        />
      )}
      {!hideSaveButton && (
        <CustomButton
          type="submit"
          onClick={() => submitRef?.current?.click()}
          className={`default-btn-save ${saveButtonClassName}`}
          label={saveButtonLabel}
          startIcon={saveButtonIcon}
        />
      )}
      {!hideFooterCancelButton && !showCloseButton && (
        <CustomButton
          size={`small`}
          label={Button.quit}
          onClick={() => onCancelActionHandler()}
          tooltipText={Tooltips.closeBtn}
          startIcon={<i className="fa-solid fa-xmark"></i>}
          className={`default-btn-light`}
        />
      )}
      {showCloseButton && (
        <CustomButton
          size={`small`}
          label={Button.close}
          onClick={() => onCancelActionHandler()}
          tooltipText={Tooltips.closeBtn}
          startIcon={<i className="fa-solid fa-xmark"></i>}
          className={`default-btn-light`}
        />
      )}
    </Modal.Footer>
  );
};

export default withTranslations(ModalFooter, 'ModalFooter');
